module.exports = __webpack_public_path__ + "img/af.afecae91f.svg";